import getMuiTheme from 'material-ui/styles/getMuiTheme';

/**
 * GoHire Brand Color Palette
 * ===========================
 * 
 * Brand / Accent (Green)
 * - Primary:       #4CAF50 (buttons, primary actions, "on" states)
 * - Hover:         #43A047
 * - Active/Pressed:#2E7D32
 * - Tint BG:       #E8F5E9 (selected rows, active menu backgrounds)
 * - Border Tint:   #A5D6A7 (subtle outlines)
 * 
 * Neutrals / Structure
 * - Top Bar Slate: #34464F (header background)
 * - Text Primary:  #263238
 * - Text Secondary:#607D8B
 * - UI Gray 50:    #FAFAFA
 * - UI Gray 100:   #F0F0F0 (sidebar background)
 * - UI Gray 200:   #E6E6E6 (dividers)
 * - Icon/Disabled: #B0BEC5
 * 
 * Status
 * - Danger/Badge:  #FF4D4F
 * - Warning Amber: #FFB300
 * - Info Blue:     #1E88E5
 */

// GoHire Green palette
export const gohireGreen = {
	primary: '#4CAF50',
	hover: '#43A047',
	active: '#2E7D32',
	tintBg: '#E8F5E9',
	borderTint: '#A5D6A7',
};

// Neutrals
export const gohireNeutrals = {
	topBarSlate: '#34464F',
	textPrimary: '#263238',
	textSecondary: '#607D8B',
	gray50: '#FAFAFA',
	gray100: '#F0F0F0',
	gray200: '#E6E6E6',
	iconDisabled: '#B0BEC5',
};

// Status colors
export const gohireStatus = {
	danger: '#FF4D4F',
	warning: '#FFB300',
	info: '#1E88E5',
};

// Menu colors
export const gohireMenu = {
	// Default (resting)
	defaultBg: '#F0F0F0',
	defaultText: '#263238',
	defaultIcon: '#607D8B',
	defaultDivider: '#E6E6E6',
	// Highlighted (hover)
	hoverBg: '#F5FBF6',
	hoverIndicator: '#A5D6A7',
	hoverText: '#263238',
	hoverIcon: '#43A047',
	// Active (selected)
	activeBg: '#E8F5E9',
	activeIndicator: '#4CAF50',
	activeText: '#2E7D32',
	activeIcon: '#2E7D32',
};

const theme = getMuiTheme({
	fontFamily: 'sans-serif',
	palette: {
		primary1Color: gohireGreen.primary,
		primary2Color: gohireGreen.hover,
		primary3Color: gohireGreen.active,
		accent1Color: gohireGreen.primary,
		pickerHeaderColor: gohireGreen.primary,
		textColor: gohireNeutrals.textPrimary,
		secondaryTextColor: gohireNeutrals.textSecondary,
		alternateTextColor: '#FFFFFF',
		canvasColor: '#FFFFFF',
		borderColor: gohireNeutrals.gray200,
		disabledColor: gohireNeutrals.iconDisabled,
	},
	appBar: {
		color: gohireNeutrals.topBarSlate,
	},
});

export default theme;
